import React, { useEffect, useMemo, useState } from "react";
import Loading from "../../../Components/Loading/Loading";
import Pagination from "../../../Components/Pagination/Pagination";
import OrderListItem from "./OrderListItem";
import Modal from "../Modals/Modal";
import { useDispatch } from "react-redux";
import { fetchReturnOrders } from "../../../Features/orderManagementSlice";
import { useSelector } from "react-redux";

const ReturnOrderList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemCount, setItemCount] = useState(6);
  const dispatch = useDispatch();

  const { loading, orders } = useSelector(
    (state) => state.orderManagement.returnOrders
  );

  useEffect(() => {
    dispatch(fetchReturnOrders());
  }, []);

  const currentTableData = useMemo(() => {
    let firstPageIndex = (currentPage - 1) * itemCount;
    let lastPageIndex;
    if (firstPageIndex > orders?.length) {
      firstPageIndex = 0;
      setCurrentPage(1);
    }
    lastPageIndex = firstPageIndex + itemCount;
    return orders?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, itemCount, orders]);

  let content;

  switch (loading) {
    case "loading":
      content = (
        <div className="flex justify-center items-center h-80">
          <Loading size={40} bgColor="#FFF"/>
        </div>
      );
      break;
    case "succeeded":
      content =
        orders?.length !== 0 ? (
          <>
            {currentTableData.map((order) => (
              <OrderListItem key={order.orderId} order={order} />
            ))}
            <Pagination
              currentPage={currentPage}
              totalCount={orders?.length}
              pageSize={itemCount}
              onPageChange={(page) => setCurrentPage(page)}
              onSizeSelect={(size) => setItemCount(size)}
            />
          </>
        ) : (
          <div className="mx-auto mt-20 flex flex-col items-center gap-6 w-3/5">
            <div className="flex flex-col gap-2 text-[#666666] items-center">
              <h1 className="font-semibold text-[18px] leading-7">
                No Return orders
              </h1>
            </div>
          </div>
        );
      break;
    default:
      content = null;
  }

  return (
    <div className="flex flex-col mt-6 mx-5 select-none">
      <div className="flex bg-[#F5F5F5] font-semibold text-[#666666]">
        <h2 className="w-[calc((35/100)*(100%-44px))] px-[10px] py-[8px] text-[14px] leading-6 uppercase">
          ORDER ID
        </h2>
        <h2 className="w-[calc((35/100)*(100%-44px))] px-[10px] py-[8px] text-[14px] leading-6 uppercase">
          RETURN REQUESTED ON
        </h2>
        <h2 className="w-[calc((15/100)*(100%-44px))] px-[10px] py-[8px] text-[14px] leading-6 uppercase">
          ORDER PRICE
        </h2>
        <h2 className="w-[calc((15/100)*(100%-44px))] px-[10px] py-[8px] text-[14px] leading-6 uppercase">
          STATUS
        </h2>
        <div className="w-[44px]"></div>
      </div>

      {content}

      <Modal />
    </div>
  );
};

export default ReturnOrderList;
